import styled from '@emotion/styled'

export const GridWrapper = styled.div`
  height: 430px;
`

export const rebuildEnabledIds = (existingIds: string[], updatedIds: string[], enabled: boolean) => {
  if (enabled) {
    return [...existingIds, ...updatedIds]
  }

  const updatedIdsLookup = new Set(updatedIds)
  return existingIds.filter(id => !updatedIdsLookup.has(id))
}
